import { useState } from 'react';

const PARENT_DEFAULT_CHILD = {
  parent_inbox:       'new',
  parent_outreach:    'sent',
  parent_negotiation: 'negotiation',
  parent_test:        'testing',
  parent_ambassador:  'active_amb',
  parent_ad:          'ad_released',
};

/**
 * DnD hook — manages drag-and-drop state and status change operations.
 *
 * @param {object} params
 * @param {object} params.changeStatusMutation — TQ mutation from useChangeLeadStatus
 * @param {function} params.addToast
 * @param {object|null} params.selectedLead — current lead detail from useLeadDetail
 */
export function useDragDrop ({ changeStatusMutation, addToast, selectedLead }) {
  const [draggedLeadId, setDraggedLeadId] = useState(null);
  const [dragStartStatus, setDragStartStatus] = useState(null);
  const [dragTargetStatus, setDragTargetStatus] = useState(null);

  const handleCardDragStart = (lead) => {
    setDraggedLeadId(lead.id);
    setDragStartStatus(lead.statusId || lead.status);
    setDragTargetStatus(lead.statusId || lead.status);
  };

  const handleCardDragEnd = () => {
    setDraggedLeadId(null);
    setDragStartStatus(null);
    setDragTargetStatus(null);
  };

  const handleColumnDragOver = (statusId) => {
    if (!draggedLeadId) return;
    setDragTargetStatus(statusId);
  };

  const handleColumnDrop = (statusId) => {
    if (!draggedLeadId || !dragStartStatus) {
      handleCardDragEnd();
      return;
    }
    const resolvedStatusId = PARENT_DEFAULT_CHILD[statusId] || statusId;
    if (dragStartStatus === resolvedStatusId) {
      handleCardDragEnd();
      return;
    }
    const leadId = draggedLeadId;
    const previousStatusId = dragStartStatus;
    handleCardDragEnd();

    changeStatusMutation.mutate(
      { leadId, statusId: resolvedStatusId, previousStatusId },
      {
        onError: (err) => {
          addToast('Ошибка', `Не удалось изменить статус: ${err.message}`, 'error');
        }
      }
    );
  };

  const handleStatusChange = (leadId, statusId) => {
    if (!leadId) return;
    const prevStatusId = selectedLead?.statusId || selectedLead?.status;
    if (prevStatusId === statusId) return;

    changeStatusMutation.mutate(
      { leadId, statusId, previousStatusId: prevStatusId },
      {
        onError: (err) => {
          addToast('Ошибка', `Не удалось изменить статус: ${err.message}`, 'error');
        }
      }
    );
  };

  const handleColumnDragLeave = (statusId) => {
    if (!draggedLeadId) return;
    setDragTargetStatus(prev => (prev === statusId ? null : prev));
  };

  return {
    draggedLeadId, dragTargetStatus,
    handleCardDragStart, handleCardDragEnd,
    handleColumnDragOver, handleColumnDrop, handleColumnDragLeave,
    handleStatusChange
  };
}
